/* eslint-disable @typescript-eslint/camelcase */
import { handleFormSubmit, useAuth, useRequest } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { confirm } from '../../../components/Dialog'
import Form from '../../../components/Form'
import type from '../../../components/Form/Fields/type'
import { REALTY_OPTION_TYPE } from '../../../config/realty-types'
import fields, { RealtyFormData } from '../fields'
import Axios from 'axios'
import routes from '../../../config/routes'
import { useHistory } from 'react-router-dom'

interface Props {
  onSubmit: () => void
  type?: REALTY_OPTION_TYPE
}

const RealtyCreateForm: React.FC<Props> = ({ onSubmit, type }) => {
  const { request } = useRequest()
  const [formFields, setFormFields] = useState(fields)
  const { token, user, setUser } = useAuth()
  const history = useHistory()

  useEffect(() => {
    window.onbeforeunload = (e: any) => {
      e.preventDefault()
      confirm({
        title: 'Confirme',
        message: 'Todas as informações preenchidas serão perdidas se você sair dessa tela.',
        buttons: [
          {
            label: 'Sim',
            onClick: () => {
              e.returnValue = true
            },
          },
          {
            label: 'Não',
            onClick: () => { },
          },
        ],
      })
    }

    return () => {
      window.onbeforeunload = (e: any) => {
      }
    }
  }, [])

  useEffect(() => {

    const formFieldsIn = fields
    fields.forEach((field, index) => {
      if (field.name === 'adult') {
        const hide = user.accept_terms_conditions
          || user.accept_privacy_policy
        formFieldsIn[index].hide = hide
        delete formFieldsIn[index].validation
        // if(formFieldsIn[index].html !== undefined)
        //   formFieldsIn[index].html.checked = hide
      }
      if (field.name === 'accept_terms_conditions') {
        formFieldsIn[index].hide = user.accept_terms_conditions
      }
      if (field.name === 'accept_privacy_policy') {
        formFieldsIn[index].hide = user.accept_privacy_policy
      }
    })

    setTimeout(() => {
      setFormFields(formFieldsIn)
    }, 0)

  }, [user])

  function submitSuccess(form: any) {
    toast.success('Imóvel registrado com sucesso.')
    setTimeout(() => {
      form.reset()
      setUser?.({ ...user, realties_count: user.realties_count + 1 })
      onSubmit()
    })
  }

  function setIndexRealty() {
    history.push(routes.realty.index.path)
  }
  return (
    <Form<RealtyFormData>
      buttonLabel="CADASTRAR"
      fields={formFields}
      initialValues={{
        wants_to_sell: true,
        type: type?.label,
        type_id: type?.value,
        accept_terms_conditions: user.accept_terms_conditions,
        accept_privacy_policy: user.accept_privacy_policy,
      } as RealtyFormData}
      onSubmit={(data, form) => {
        return handleFormSubmit({
          request: request({
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/realties`,
            data,
          }),
          onValidationErrors: () => toast.error('Erros de validacao.'),
          onSuccess: (data) => {
            setUser?.({...user,
              accept_terms_conditions: user.accept_terms_conditions,
              accept_privacy_policy: user.accept_privacy_policy})

            if (data.status === 202) {
              confirm({
                title: 'Informação',
                message: data.data.data.message,
                buttons: [
                  {
                    label: 'Sim',
                    onClick: () => {
                      data.birth_year = user.birth_year
                      data.contact_my_city = true
                      setIndexRealty()
                      Axios({
                        method: 'PUT',
                        url: `${process.env.REACT_APP_API_URL}/users/${user.id}`, data ,
                        headers: {
                          Authorization: `Bearer ${token}`,
                        },

                      }).then(({ data }) => {
                      })
                    },
                  },
                  {
                    label: 'Não',
                    onClick: () => {
                      setIndexRealty()
                    },
                  },
                ],
              })
            } else {
              submitSuccess(form)
            }
          },
          onFailure: () => toast.error('Erro ao alterar informações.'),
        })
      }}
    />
  )
}

export default RealtyCreateForm
